import neoInfADI from '@/sui/data/sheets/edit/cfg/neoInfADI'
import patient from '@/sui/data/sheets/edit/patient'
import bact from '@/sui/data/sheets/edit/bact'
import catheter from '@/sui/data/sheets/edit/catheter'
import multi from '@/sui/data/sheets/edit/multi'

import {
  fromField,
  bactDistribution,
  moDistribution,
  locDistribution
} from '@/sui/data/caracteristics/tools'

function neoInfKtDistribution (e) {
  const type = neoInfADI.catheterType.v3.config.values.find(
    v => v.code === e
  ).value

  return [
    { f: `kt_${e}_insertionSite`, t: `${type}`, h: true },
    fromField(`kt_${e}_insertionSite`, bact.insertionSite.full, 9),
    { f: `kt_${e}_lapse`, t: `Durée de cathétérisme`, minimizeDecimalScale: true },
    fromField(`kt_${e}_material`, neoInfADI.material, 9),
    fromField(`kt_${e}_ventilation`, patient.neoVentilation, 9),
    fromField(`kt_${e}_lipids`, neoInfADI.lipids, 9),
    fromField(`kt_${e}_removed`, catheter.removed, 9),
    fromField(`kt_${e}_removalReason`, neoInfADI.removalReason, 9),
    fromField(`kt_${e}_laboratory`, catheter.labo.v2, 9),
    fromField(`kt_${e}_isColIlcBlcSep`, neoInfADI.isColIlcBlcSep, 9),
    {
      f: `kt_${e}_colIlcBlcSepOrigin`,
      t: 'Colonisations, ILC, BLC et sepsis',
      h: true
    },
    fromField(`kt_${e}_colIlcBlcSepOrigin`, neoInfADI.colIlcBlcSepOrigin.v2, 9),
    fromField(`kt_${e}_lipidsDiagnosis`, neoInfADI.lipidsDiagnosis.v1, 9),
    fromField(`kt_${e}_covidStatus`, multi.covidStatus.std, 9),
    fromField(`kt_${e}_blcCriteria`, bact.divDiag.v1.neo, 9),
    fromField(`kt_${e}_divDiag`, neoInfADI.blcCriteria.v2, 9),
    {
      f: `kt_${e}_clinicalSigns`,
      t: 'Pour les BLC avec critère BLC 5',
      h: true
    },
    fromField(`kt_${e}_clinicalSigns`, bact.clinicalSigns, 9),
    fromField(`kt_${e}_bioSigns`, bact.bioSigns, 9),
    fromField(`kt_${e}_adaptedAntibio`, bact.adaptedAntibio, 9),
    fromField(`kt_${e}_twoHemocs`, bact.twoHemocs, 9)
  ]
}

export default function (estb, year) {
  return [
    ...locDistribution('', 'patients', { estb: estb, year: year }),
    {
      title: 'Caractéristiques des patients',
      key: 'pat',
      list: [
        { f: `aged`, t: 'Âge (en jours)', minimizeDecimalScale: true },
        fromField(`sex`, patient.sex, 9),
        fromField(`birthSite`, patient.birthSite, 9),
        fromField(`origin`, patient.neoOrigin, 9),
        fromField(`cribII`, patient.cribII.std),
        fromField(`birthWeight`, patient.birthWeight),
        fromField(`gestationalAge`, patient.gestationalAge),
        fromField(`leucomalacy`, patient.leucomalacy, 9),
        fromField(`dead`, patient.dead, 9),
        fromField(`future`, neoInfADI.future.v2, 9),
        fromField('covidStatus', multi.covidStatus.exit, 9)
      ]
    },
    {
      title: 'Caractéristiques des cathéters centraux',
      key: 'kt',
      list: [
        fromField('kt_type', neoInfADI.catheterType.v3),
        { f: 'kt_lapse', t: 'Durée de cathétérisme', minimizeDecimalScale: true },
        fromField('kt_material', neoInfADI.material, 9),
        fromField('kt_insertionSite', bact.insertionSite.full, 9),
        fromField('kt_ventilation', patient.neoVentilation, 9),
        fromField('kt_lipids', neoInfADI.lipids, 9),
        fromField('kt_removed', catheter.removed, 9),
        fromField('kt_removalReason', neoInfADI.removalReason, 9),
        fromField('kt_laboratory', catheter.labo.v2, 9),
        fromField('kt_isColIlcBlcSep', neoInfADI.isColIlcBlcSep, 9),
        {
          f: 'kt_colIlcBlcSepOrigin',
          t: 'Colonisations, ILC, BLC et sepsis',
          h: true
        },
        fromField('kt_colIlcBlcSepOrigin', neoInfADI.colIlcBlcSepOrigin.v2, 9),
        fromField('kt_lipidsDiagnosis', neoInfADI.lipidsDiagnosis.v1, 9),
        fromField(`kt_covidStatus`, multi.covidStatus.std, 9),
        fromField('kt_blcCriteria', neoInfADI.blcCriteria.v1, 9),
        fromField('kt_divDiag', neoInfADI.blcCriteria.v2, 9),
        {
          f: 'kt_clinicalSigns',
          t: 'Pour les BLC avec critère BLC 5',
          h: true
        },
        fromField('kt_clinicalSigns', bact.clinicalSigns, 9),
        fromField('kt_bioSigns', bact.bioSigns, 9),
        fromField('kt_adaptedAntibio', bact.adaptedAntibio, 9),
        fromField('kt_twoHemocs', bact.twoHemocs, 9),
        ...neoInfKtDistribution('C1'),
        ...neoInfKtDistribution('C3'),
        ...neoInfKtDistribution('C4')
      ]
    },
    moDistribution('kt_blc_', 'bactériémies liées aux cathéters centraux', year),
    moDistribution('kt_nblc_', 'infections hors bactériémies liées aux cathéters centraux', year),
    bactDistribution('b_', 'bactériémies hors cathéters centraux', { covid: true }),
    moDistribution('b_', 'bactériémies hors cathéters centraux', year),
    {
      title: 'Caractéristiques des sepsis hors cathéters centraux',
      key: 'seps',
      list: [
        fromField('s_origin', neoInfADI.sepOrigin.v2, 9),
        fromField(`s_covidStatus`, multi.covidStatus.std, 9),
        {
          f: `s_entrance`,
          t: `Distribution des portes d'entrée`,
          v: bact.entrance.v3.all.config.values
        }
      ]
    }
  ]
}
